import { formatDateFromSelect } from "./formatDateFromSelect";

interface SelectOption {
  value: string;
  label?: string;
}

interface FormatUrlParamsProps {
  centerCost: SelectOption[];
  branch: SelectOption[];
  startDate?: Date | null;
  endDate?: Date | null;
  baseUrl: string;
  tim?: boolean;
}

export function formattUrlParams({
  centerCost = [],
  branch = [],
  startDate = null,
  endDate = null,
  tim = false,
  baseUrl,
}: FormatUrlParamsProps): string {
  let urlQueryParamsCC = "";
  if (centerCost.length !== 0) {
    const all = centerCost.find(({ value }) => value === "all");
    if (!all) {
      const cc = centerCost.map(({ value }) => value).join(",");
      urlQueryParamsCC = `cc=${cc}`;
    }
  }

  let urlQueryParamsBranch = "";
  if (branch.length !== 0) {
    const all = branch.find(({ value }) => value === "all");
    if (!all) {
      const branchValues = branch.map((value) => value).join(",");
      urlQueryParamsBranch = `branch=${branchValues}`;
    }
  }

  let urlQueryParamsStartDate = "";
  if (startDate) {
    const formattedStartDate = formatDateFromSelect(startDate);
    urlQueryParamsStartDate = `startDate=${formattedStartDate}`;
  }

  let urlQueryParamsEndDate = "";
  if (endDate) {
    const formattedEndDate = formatDateFromSelect(endDate);
    urlQueryParamsEndDate = `endDate=${formattedEndDate}`;
  }

  let urlQueryParamsTim = "";
  if (tim) {
    urlQueryParamsTim = `tim=${true}`;
  }

  const queryParams = [
    urlQueryParamsCC,
    urlQueryParamsBranch,
    urlQueryParamsStartDate,
    urlQueryParamsEndDate,
    urlQueryParamsTim,
  ].filter((param) => param !== "");

  return queryParams.length > 0 ? `${baseUrl}?${queryParams.join("&")}` : baseUrl;
}
